package er.prateek.crossly.firebase

/**
 * Typed reads of the flags in [RemoteConfigKeys], each falling back to
 * [RemoteConfigDefaults] whenever the value hasn't loaded yet or is out of range -- see
 * [RemoteConfigClient.warmUp].
 */

/** Not yet consumed by any screen -- there's no Quizzes UI to gate until Phase 7. */
fun RemoteConfigClient.quizzesEnabled(): Boolean = getBoolean(RemoteConfigKeys.QUIZZES_ENABLED)

fun RemoteConfigClient.hintsMaxPerPuzzle(): Long {
    val value = getLong(RemoteConfigKeys.HINTS_MAX_PER_PUZZLE)
    return if (value > 0) value else RemoteConfigDefaults.HINTS_MAX_PER_PUZZLE
}
